<template>
  <div>
    <div @click="open" class="about-btn"></div>
    <el-dialog :visible="showModal" width="80%" :show-close="false" :modal-append-to-body="false">
      <div @click="close" class="about-close">
        <img src="@/assets/image/icon_close.png"/>
      </div>
      <div class="about-img">
        <img src="@/assets/image/img_about.png"/>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    open() {
      this.showModal = true;
    },
    close() {
      this.showModal = false;
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .el-dialog {
  background-color: transparent;
}

.about-close {
  position: absolute;
  right: -50px;
  top: -50px;
  width: 100px;
  height: 100px;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
  }
}

.about-btn {
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -700px;
  width: 1400px;
  height: 130px;
  background-color: transparent;
  cursor: pointer;
}

.about-img {
  width: 100%;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
